import { createAsyncThunk } from "@reduxjs/toolkit";
import { axios, getToken, URL_API } from "../../utils";

export const getTransferById = createAsyncThunk(
  "get/transfer/id",
  async ({ id, type }, { rejectWithValue }) => {
    try {
      const res = await axios({
        url: `${URL_API}/transfer-receive/${type}/${id}`,
        headers: { Authorization: "Bearer " + getToken() },
      });
      return res.data.data;
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);
